import { FC } from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';
import SecondaryText from './typography/SecondaryText.tsx';
import { Children } from '../constants/types/prop.types.ts';

type Props = Pick<NavLinkProps, 'to' | 'replace' | 'className'> & Children;

const HyperLink: FC<Props> = ({ children, ...props }) => (
  <NavLink {...props}>
    <SecondaryText className="underline text-primary py-[8px] inline">{children}</SecondaryText>
  </NavLink>
);

export default HyperLink;
